import React from "react";
import MaskedInput from "react-text-mask";

class Tin extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <MaskedInput 
                guide={false} 
                mask={[/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}  
                placeholder="000-000-000-0000" 
                type="text" 
                value={this.props.value} 
                onChange={this.props.onChange}
            />
        );
    }
}

export default Tin;